<template>
  <CommunityNavWrapper>
    <div class="terms-notice bg-white border-md">
      <div class="image-container">
        <FeedItemImage
          class="hero-image"
          :image-source-url="imageUrl"/>
        <div class="image-gradient"/>
      </div>
      <div class="cta px-lg py-md">
        <h4 class="mb-sm">
          Welcome to Our Community
        </h4>
        <p class="mb-md">
          Before you can view and participate in the Community feed, please review and accept our
          <BaseLink
            to="https://support.armoire.style/legal#EULA"
            class="color-orchid text-decoration-underline">
            Community Guidelines.
          </BaseLink>
        </p>
        <p class="small-text color-pewter mb-lg">
          By clicking "Accept &amp; Continue", you agree to treat all community members with respect,
          follow our content guidelines, and help us maintain a positive, inclusive environment.
          Violation of these guidelines may result in removal of content or suspension of community access.
        </p>
        <BaseButton
          :disabled="accepting"
          text="Accept & Continue"
          @click="acceptTerms"/>
      </div>
    </div>
  </CommunityNavWrapper>
</template>

<script setup>
import { ref } from 'vue'
import BaseLink from '@shared/components/BaseLink.vue'
import BaseButton from '@shared/components/ADORN/BaseButton.vue'
import CommunityNavWrapper from '../common/CommunityNavWrapper.vue'
import FeedItemImage from './FeedItemImage.vue'
import { useCommunityStore } from '@/stores/community.js'
import { captureException } from '@sentry/vue'

const communityStore = useCommunityStore()

const accepting = ref(false)
const imageUrl = `${import.meta.env.VITE_WEBSITE_IMAGES_URL}kim-mitchell-example-post.jpg`

async function acceptTerms () {
  accepting.value = true
  try {
    await communityStore.acceptCommunityTerms()
  } catch (e) {
    captureException(e)
  } finally {
    accepting.value = false
  }
}
</script>

<style lang="scss" scoped>
$image-height-mobile: 35vh;
$image-height-desktop: 42vh;

.terms-notice {
  @include media-tablet-or-larger {
    border: $default-border;
  }
}

.image-container {
  position: relative;
}

.hero-image {
  height: $image-height-mobile;
  overflow: hidden;

  @include media-tablet-or-larger {
    height: $image-height-desktop;
  }
}

.image-gradient {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  background: linear-gradient(to bottom, transparent 50%, $white 100%);
  pointer-events: none;
}

.cta {
  position: relative;
  margin-top: -5vh;
}
</style>

